import React from 'react';

import { useQuery } from '@apollo/client';
import { Navigate } from 'react-router-dom';

import { ME } from 'graphql/auth';

export const AuthGuard: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const { called, loading, data } = useQuery(ME, {
    fetchPolicy: 'network-only'
  });

  if (loading) return <></>;

  if (called && !data) return <Navigate to="/login" />;

  return children;
};
